module.exports = __webpack_public_path__ + "static/media/IMAGEN-TELEPHARMACY.ac32d729.png";